var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFailPayment = function SvgFailPayment(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2810",
    "data-name": "Group 2810",
    width: 60.185,
    height: 60.287,
    viewBox: "0 0 60.185 60.287",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2666",
    "data-name": "Rectangle 2666",
    width: 60.185,
    height: 60.286,
    fill: "#f1585e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26585",
    "data-name": "Path 26585",
    d: "M32.317,0c1.041.155,2.09.27,3.122.473A29.636,29.636,0,0,1,56.413,15.554a29.642,29.642,0,0,1,3.728,16.393A12.879,12.879,0,0,1,59.96,33.7a2.93,2.93,0,0,1-5.8-.789,24.878,24.878,0,0,0-.195-6.683A23.824,23.824,0,0,0,42.775,9.53,23.252,23.252,0,0,0,29.79,5.937,24,24,0,0,0,6.436,25.214c-1.856,9.473,1.033,17.5,8.428,23.761a22.833,22.833,0,0,0,12.4,5.265,23.9,23.9,0,0,0,15.506-3.434,3.18,3.18,0,0,1,2.441-.571,2.947,2.947,0,0,1,.978,5.4,29.5,29.5,0,0,1-10.057,4.048c-1.26.252-2.54.407-3.811.606H27.852c-.674-.09-1.35-.169-2.023-.271A30.206,30.206,0,0,1,.476,35.448C.275,34.394.157,33.325,0,32.263V27.906c.038-.17.083-.339.114-.511A44.212,44.212,0,0,1,1.1,22.1C4.789,10.259,12.673,2.979,24.85.472,25.879.261,26.929.155,27.969,0Z",
    transform: "translate(0.092 0.264)",
    fill: "#f1585e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M13728.477-5678.109l-6.011-6.01-6.012,6.01a3,3,0,0,1-4.243,0,3,3,0,0,1,0-4.243l6.011-6.01-6.011-6.009a3,3,0,0,1,0-4.243,3,3,0,0,1,4.243,0l6.012,6.01,6.011-6.01a3,3,0,0,1,4.243,0,3,3,0,0,1,0,4.243l-6.011,6.009,6.011,6.01a3.007,3.007,0,0,1,0,4.243,2.991,2.991,0,0,1-2.122.879A2.99,2.99,0,0,1,13728.477-5678.109Z",
    transform: "translate(-13692.24 5718.756)",
    fill: "#f1585e"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFailPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fail-payment.e020678d.svg";
export { ForwardRef as ReactComponent };